const actionTypeConstants = {
    CURRENT_PAGE_CONTEXT:'CURRENT_PAGE_CONTEXT',
    CUSTOMER_JOURNEY:'CUSTOMER_JOURNEY',
    UPDATE_HISTORY_INDEX: "UPDATE_HISTORY_INDEX",
    UPDATE_BACK_LINK: 'UPDATE_BACK_LINK',
    UPDATE_PAGE_COUNT: "UPDATE_PAGE_COUNT",
    INIT: 'INIT',

}

export default actionTypeConstants